import React from "react";
import { useColorTheme } from "contexts/color-theme";
import { Link, type LinkProps } from "ui/link";
import { Box, forwardRef } from "@chakra-ui/react";

type NavLinkProps = {
  isActive?: boolean;
  isDimmed?: boolean;
} & LinkProps;

export const NavLink = forwardRef<NavLinkProps, typeof Link>((props, ref) => {
  const { bgColor, theme } = useColorTheme();
  const { isActive, isDimmed, children, ...linkProps } = props;

  const activeBgColor =
    bgColor === "white" ? `brand.backgroundSecondary.light` : `brand.header.backgroundSecondary.${theme}`;

  return (
    <Link
      ref={ref}
      variant="nav"
      // Increase z-index when active to ensure the focus state outline is visible
      zIndex={isActive ? "popover" : "auto"}
      {...linkProps}
    >
      {/**
       * Separate background hover styles into their own div to avoid flickering
       * when the mouse hovers over dead space between links and their border radii.
       **/}
      <Box
        bgColor={isActive ? activeBgColor : "transparent"}
        borderRadius="base"
        color={isDimmed ? `brand.textSecondary.${theme}` : "inherit"}
        px={{ base: "smallest", xl: "smaller" }}
        py="smallest"
        transition="all 0.15s ease-in-out"
      >
        {children}
      </Box>
    </Link>
  );
});
